
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.649 13.617"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_74437","data-name":"Group 74437","transform":"translate(-138.582 -2.972)"}},[_c('path',{attrs:{"id":"Path_774","data-name":"Path 774","d":"M138.808,7.492h2.832v9.1h-2.832Zm1.416-4.52a1.64,1.64,0,1,1-1.642,1.638,1.639,1.639,0,0,1,1.642-1.638","fill":"currentColor"}}),_c('path',{attrs:{"id":"Path_775","data-name":"Path 775","d":"M143.413,7.492h2.712V8.736h.037a2.974,2.974,0,0,1,2.678-1.469c2.863,0,3.391,1.883,3.391,4.333v4.989H149.4V12.166c0-1.056-.021-2.412-1.47-2.412-1.471,0-1.7,1.149-1.7,2.335v4.5h-2.826Z","fill":"currentColor"}})])])
          )
        }
      }
    